// extracted by mini-css-extract-plugin
export default {"wrapper":"holy-grail_wrapper__D5qAb","main":"holy-grail_main__0WkH-","main__wrapper":"holy-grail_main__wrapper__VjfCE"};